export default "__VITE_ASSET__ffc07bc5__"